import { Modal as ModalAntd } from 'antd'
import { Powered } from 'component/Powered/Powered'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { ReactNode } from 'react'
import { opt } from 'store/opt'
import { styles } from 'util/style'
import css from './Modal.module.scss'

type Props = {
  children?: ReactNode
  onCancel?(): void
  stable?: boolean
  title?: string
  width?: number
  round?: number
  gap?: number
  compact?: boolean
}

export const Modal = (props: Props) => {
  const { children, onCancel, stable, title, round, gap, compact } = props
  const powered = opt.stand && opt.footer && !compact
  const width = props.width ?? 480
  const style = styles({
    '--ui-modal-border-radius': round ? round + 'px' : undefined,
  })

  useBodyScrollLock(true)

  return <ModalAntd className={css.modal} rootClassName={css.root} style={style} open title={title} onCancel={onCancel}
    width={width} footer={null} destroyOnClose maskClosable={!stable} keyboard={false} closeIcon={!!onCancel}>
    <Vertical gap={gap ?? 42}>
      {children}
    </Vertical>
    {powered && <Space center>
      <Powered />
    </Space>}
  </ModalAntd>
}
